import Swal, { SweetAlertIcon } from "sweetalert2";

export interface swalProps {
    title?: string;
    message?: string;
    icon?: SweetAlertIcon;
    textAlign?: "right" | "left" | "center" | "leftWar";
    denyButtonText?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    buttonAlign?: "right" | "left" | "center";
    buttonOrder?: buttonOrder
}

export interface buttonOrder {
    confirm?: number,
    deny?: number,
    cancel?: number
}

class SwalUtil {
    private static textAlign(textAlign: string | undefined): string {
        switch (textAlign) {
            case "right":
                return "text-align: right; margin-right: 17%; padding-top: 5%"
            case "left":
                return "text-align: left; margin-left: 17%; padding-top: 5%"
            case "leftWar":
                return "text-align: left; margin-left: 10%; padding-top: 5%"
            default:
                return "text-align: center; padding-top: 5%"
        }
    }

    private static buttonAlign(buttonAlign: string | undefined): string {
        switch (buttonAlign) {
            case "right":
                return "action-right"
            case "left":
                return "action-left"
            default:
                return "action-center"
        }
    }

    /**
       *　ラベル付き情報ポップアップ
       *
       * return:SweetAlertイベント（Promise）
    */
    static labelInfo(props: swalProps) {
        const icon = props.icon ? props.icon : "info"
        const html = `
                <h2 class="swal2-title label-title-info" id="swal2-title" style="display: block; font-weight:normal; box-sizing:content-box;">${props.title}</h2>
                <div class="swal2-icon swal2-${icon} swal2-icon-show" style="display: flex;"><div class="swal2-icon-content">!</div></div>
                <div style="${this.textAlign(props.textAlign)}">
                    ${props.message}
                </div>
            `
        return Swal.fire({
            html: html,
            showDenyButton: props.denyButtonText != undefined,
            showCancelButton: props.cancelButtonText != undefined,
            denyButtonText: props.denyButtonText,
            confirmButtonText: props.confirmButtonText,
            cancelButtonText: props.cancelButtonText,
            customClass: {
                popup: 'label-popup',
                htmlContainer: 'label-container',
                actions: this.buttonAlign(props.buttonAlign),
                confirmButton: 'order-' + props.buttonOrder?.confirm + ' custom-confirm-button-info',
                denyButton: 'order-' + props.buttonOrder?.deny + ' custom-deny-button',
                cancelButton: 'order-' + props.buttonOrder?.cancel + ' custom-cancel-button'
            },
            didOpen: () => {
                const confBtn = Swal.getConfirmButton();
                if (confBtn) {
                    // 基本のシャドウを設定
                    confBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';

                    // ホバー時のイベントリスナー
                    confBtn.onmouseenter = () => {
                        // ホバー時に色が変わらないよう、元の背景色を再設定
                        confBtn.style.backgroundColor = '#41DBCE';
                        // 影を強調する
                        confBtn.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
                    };

                    // マウスが離れた時の設定
                    confBtn.onmouseleave = () => {
                        confBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                    };
                }
            }
        })
    }

    /**
       *　ラベル付き警告ポップアップ
       *
       * return:SweetAlertイベント（Promise）
    */
    static labelWarning(props: swalProps) {
        const icon = props.icon ? props.icon : "warning"
        const html = `
                <h2 class="swal2-title label-title-warning" id="swal2-title" style="display: block; font-weight:normal;  height:45px">${props.title}</h2>
                <div class="swal2-icon swal2-${icon} swal2-icon-show" style="display: flex;"><div class="swal2-icon-content">!</div></div>
                 <div style="${this.textAlign(props.textAlign)}">
                    ${props.message}
                </div>
            `
        return Swal.fire({
            html: html,
            showDenyButton: props.denyButtonText != undefined,
            showCancelButton: props.cancelButtonText != undefined,
            denyButtonText: props.denyButtonText,
            confirmButtonText: props.confirmButtonText,
            cancelButtonText: props.cancelButtonText,
            customClass: {
                popup: 'label-popup',
                htmlContainer: 'label-container',
                actions: this.buttonAlign(props.buttonAlign),
                confirmButton: 'order-' + props.buttonOrder?.confirm + ' custom-confirm-button-warning',
                denyButton: 'order-' + props.buttonOrder?.deny + ' custom-deny-button',
                cancelButton: 'order-' + props.buttonOrder?.cancel + ' custom-cancel-button'
            },
            didOpen: () => {
                const confBtn = Swal.getConfirmButton();
                const denyBtn = Swal.getDenyButton();
                if (confBtn) {
                    // 基本のシャドウを設定
                    confBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';

                    // ホバー時のイベントリスナー
                    confBtn.onmouseenter = () => {
                        // ホバー時に色が変わらないよう、元の背景色を再設定
                        confBtn.style.backgroundColor = '#FF8C45';
                        // 影を強調する
                        confBtn.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
                    };

                    // マウスが離れた時の設定
                    confBtn.onmouseleave = () => {
                        confBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                    };
                }

                if (denyBtn) {
                    // 基本のシャドウを設定
                    denyBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                    // ホバー時のイベントリスナー
                    denyBtn.onmouseenter = () => {
                        // ホバー時に色が変わらないよう、元の背景色を再設定
                        denyBtn.style.backgroundColor = '#BFBFBF';
                        // 影を強調する
                        denyBtn.style.boxShadow = '0 5px 15px rgba(0,0,0,0.3)';
                    };
                    // マウスが離れた時の設定
                    denyBtn.onmouseleave = () => {
                        denyBtn.style.boxShadow = '0 2px 4px rgba(0,0,0,0.2)';
                    };
                }
            }
        })
    }

    /**
       *　ラベル付きエラーポップアップ
       *
       * return:SweetAlertイベント（Promise）
    */
    static labelError(props: swalProps) {
        const icon = props.icon ? props.icon : "error"
        const html = `
                <h2 class="swal2-title label-title-error" id="swal2-title" style="display: block; font-weight:normal;">${props.title}</h2>
                <div class="swal2-icon swal2-${icon} swal2-icon-show" style="display: flex;"><div class="swal2-icon-content">!</div></div>
                <div style="${this.textAlign(props.textAlign)}">
                    ${props.message}
                </div>
            `
        return Swal.fire({
            html: html,
            showDenyButton: props.denyButtonText != undefined,
            showCancelButton: props.cancelButtonText != undefined,
            denyButtonText: props.denyButtonText,
            confirmButtonText: props.confirmButtonText,
            cancelButtonText: props.cancelButtonText,
            customClass: {
                popup: 'label-popup',
                htmlContainer: 'label-container',
                actions: this.buttonAlign(props.buttonAlign),
                confirmButton: 'order-' + props.buttonOrder?.confirm + ' custom-confirm-button-error',
                denyButton: 'order-' + props.buttonOrder?.deny + ' custom-deny-button',
                cancelButton: 'order-' + props.buttonOrder?.cancel + ' custom-cancel-button'
            }
        })
    }
}


export default SwalUtil
